import { jsxs as h, jsx as r } from "react/jsx-runtime";
import * as d from "react";
import { cn as c } from "../../../lib/utils.js";
const j = d.forwardRef(({ className: k, value: g = "", onChange: l, label: a, error: t, helperText: u, variant: o = "default", size: i = "md", disabled: s, id: N, ...y }, $) => {
  const m = N || d.useId(), [P, v] = d.useState(g), w = (n) => {
    const e = n.replace(/\D/g, "");
    return e.length >= 6 ? `(${e.slice(0, 3)}) ${e.slice(3, 6)}-${e.slice(6, 10)}` : e.length >= 3 ? `(${e.slice(0, 3)}) ${e.slice(3)}` : e;
  }, I = (n) => {
    const f = n.target.value.replace(/\D/g, "").slice(0, 10), x = w(f);
    v(x), l == null || l(f, `+1 ${x}`);
  }, p = {
    sm: "h-8 text-xs",
    md: "h-10 text-sm",
    lg: "h-12 text-base"
  }, b = {
    default: "border border-border-color bg-bg-surface rounded-lg",
    minimal: "border-0 border-b-2 border-border-color bg-transparent rounded-none",
    enclosed: "border-0 bg-bg-muted rounded-lg"
  };
  return h("div", { className: "w-full space-y-1.5", children: [a && r("label", { htmlFor: m, className: "block text-sm font-medium text-text-primary", children: a }), h("div", { className: "relative flex", children: [r("div", { className: c("flex items-center px-3 border-r border-border-color bg-bg-muted text-text-secondary select-none", p[i], b[o], o === "default" && "rounded-r-none", s && "opacity-50 cursor-not-allowed"), children: r("span", { className: "text-sm font-medium", children: "+1" }) }), r("input", { ref: $, id: m, type: "tel", value: P, onChange: I, disabled: s, placeholder: "(555) 000-0000", className: c("flex-1 px-3 transition-all duration-300 ease-luxury", "focus:outline-none focus:ring-2 focus:ring-lpr-gold/50 focus:border-lpr-gold", "placeholder:text-text-secondary dark:placeholder:text-lpr-neutral/30", p[i], b[o], o === "default" && "rounded-l-none border-l-0", t && "border-lpr-red focus:ring-lpr-red/50", s && "opacity-50 cursor-not-allowed"), ...y })] }), (t || u) && r("p", { className: c("text-xs", t ? "text-lpr-red" : "text-text-secondary"), children: t || u })] });
});
j.displayName = "PhoneInput";
export {
  j as PhoneInput
};
//# sourceMappingURL=PhoneInput.js.map
